var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.getColor(_vm.item._deleted)}})}
var staticRenderFns = []

export { render, staticRenderFns }